module.exports = __webpack_public_path__ + "static/media/saved-reports-hero.3ff9f49d.png";